import { useConfirmEmailBySlackTokenMutation } from '@/query/mutations/useConfirmEmailBySlackTokenMutation';
import type { ConfirmEmailBySlackTokenType } from '@/shared/types/auth';

export const useConfirmEmailBySlackToken = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: ConfirmEmailBySlackTokenType) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
}) => {
  const {
    mutateAsync: confirmEmailBySlackTokenAsync,
    isPending: isConfirmingEmailBySlackToken,
  } = useConfirmEmailBySlackTokenMutation({
    onSuccess: async (res) => {
      if (onSuccess) {
        onSuccess(res);
      }
    },
    onError: (error) => {
      const customError = error as Error & { status?: string; code?: number };

      if (onError)
        onError({
          status: customError.status,
          message: customError.message,
          code: customError.code,
        });
    },
  });

  return { confirmEmailBySlackTokenAsync, isConfirmingEmailBySlackToken };
};
